<template>
    <b-card>
        <b-card-body>
            <p>
                <label style="font-weight: bold">Total Quantity:</label>&nbsp;{{
                    totalQty
                }}
            </p>
            <b-form inline>
                <label class="sr-only" for="inline-form-input-quantity"
                    >Quantity</label
                >
                <b-form-input
                    id="inline-form-input-quantity"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="Quantity On Hand"
                    v-model="model.quantity_on_hand"
                    type="number"
                ></b-form-input>

                <label class="sr-only" for="inline-form-input-section"
                    >Section</label
                >

                <b-form-select
                    id="inline-form-input-section"
                    v-model="model.location_section_id"
                    :options="warehouses"
                    value-field="id"
                    text-field="name"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled
                            >Warehouse Section</b-form-select-option
                        >
                    </template>
                </b-form-select>

                <b-button variant="primary" @click="onSubmit">Update</b-button>
            </b-form>
            <b-table
                striped
                hover
                responsive
                :items="inventoryList"
                :fields="fields"
            ></b-table>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'ItemInventory',
    props: ['master_item_id'],
    data() {
        return {
            model: {
                master_item_id: null,
                location_section_id: null,
                quantity_on_hand: null,
            },
            fields: ['quantity_on_hand', 'locationSection'],
        }
    },
    computed: {
        warehouses() {
            return this.$store.getters['locations/warehouse_sections']
        },

        masterItem() {
            return this.$store.state.masterItem.item
        },
        totalQty() {
            return this.inventoryList.reduce((_sum, item) => {
                _sum += item.quantity_on_hand
                return _sum
            }, 0)
        },
        inventoryList() {
            return ((this.masterItem || {}).sections || []).map(x => ({
                location_section_id: x.location_section_id,
                master_item_id: x.master_item_id,
                quantity_on_hand: x.quantity_on_hand,
                locationSection: `${x.location_section.location.name}, ${x.location_section.name}`,
            }))
        },
    },

    methods: {
        async onSubmit() {
            const model = {
                ...this.model,
            }

            model.master_item_id = this.master_item_id
            await this.$store.dispatch('inventory/createInventory', model)
            await this.$store.dispatch(
                'masterItem/fetchById',
                this.master_item_id
            )

            console.log('masterItem', this.masterItem)
        },
    },
}
</script>